import { Component, Inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { DTypeFormDateField } from '@grupo-constant/next-dtype/form';
import { Datepicker, DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { formatISO } from 'date-fns';
import { DateFormat } from '../../dtype-date';
import { DTypeFormFieldComponent } from '../../dtype-field.model';

import { TranslocoModule } from '@ngneat/transloco';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LocalizePipe } from '../../../pipes/standalone/localize.pipe';
import { LocalizeDatePipe } from '../../../pipes/localizeDate.pipe';

@Component({
    selector: 'datepicker-field-component',
    templateUrl: './datepicker-field.component.html',
    providers: [
        { provide: MAT_DATE_FORMATS, useClass: DateFormat },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDatepickerModule, LocalizePipe, TranslocoModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, LocalizeDatePipe]
})
export class DtypeDatepickerFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormDateField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    min: Date;
    max: Date;
    remote: boolean;

    constructor(@Inject(MAT_DATE_FORMATS) private dateFormat: DateFormat) { }

    ngOnInit() {
        this.remote = (this.field.dTypeCol as Datepicker).remote;
        if (this.field.min) {
            this.min = new Date(this.field.min);
        }
        if (this.field.max) {
            this.max = new Date(this.field.max);
        }

        this.dateFormat.style = (this.field.dTypeCol as Datepicker).style;

        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
    }

    dateChange(event: any) {
        this.field.control.setValue(event.value ? formatISO(Date.parse(String(event.value)), { representation: 'date' }) : '');
    }

    openDatepickerOnClick(datepicker: MatDatepicker<Date>) {
        if (!datepicker.opened) {
            datepicker.open();
        }
    }

}
